import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation, useQueryClient } from 'react-query';

import { companyConfigConstants } from '..';

export const useCompanyConfigDocumentTemplateFormatSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { format: 'WORD' | 'PDF' }) => {
      const res = await $api.post(
        stringifyUrl({
          url: '/v1/company-config/document-template/format',
          query: data
        })
      );

      return res.data;
    },
    {
      onSuccess: (_, variable) => {
        qc.setQueryData(
          [companyConfigConstants.queryKeys.COMPANY_CONFIG_DOCUMENT_TEMPLATE_FORMAT],
          () => variable?.format
        );
      }
    }
  );
};
